import React from 'react';
import Spinner from 'UI/Elements/Spinner';
var LoadingPage = function LoadingPage() {
  return /*#__PURE__*/React.createElement("div", {
    className: "loading-page-overview"
  }, /*#__PURE__*/React.createElement(Spinner, {
    center: true
  }));
};
export default LoadingPage;